// extracted by mini-css-extract-plugin
module.exports = {"legal":"az_jjb","headline":"az_kjb"};